import * as React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Helmet from 'react-helmet';
import { omit } from 'lodash';

import NoMatch from './NoMatch';
import { SideBar } from '../components';
import AppConfig from '../config/AppConfig';
import { DUMMY_NAV_ITEMS } from './NavItems';
import { isLoggedIn, currentUserPermissionCheck } from '../utils/helpers';
import { PublicRoutes, PrivateRoutes } from './Routes';
import FillLoader from '../components/loaders/FillLoader';
import EditContactUs from '../containers/contactUs/EditContactUs';

const PrivateRoute = ({ component: Component, permissions, ...rest }: any & { component: any }) => (
  <Route
    {...rest}
    render={(props) => {
      if (isLoggedIn()) {
        if (currentUserPermissionCheck(permissions)) {
          return (
            <SideBar
              navItems={DUMMY_NAV_ITEMS}
              children={
                <React.Suspense fallback={<FillLoader />}>
                  <Component {...props} {...rest} />
                </React.Suspense>
              }
            />
          );
        } else {
          return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
        }
      } else {
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
      }
    }}
  />
);

export const PublicRoute = (props: any) => {
  const Comp = props.component;
  const cleanProps = omit(props, 'component');
  return props.private && !isLoggedIn() ? (
    <Redirect to={{ pathname: '/', state: { from: props.location } }} />
  ) : (
    <Route {...cleanProps} component={(renderProps: any) => <Comp {...renderProps} />} />
  );
};

const AppNavigation = () => (
  <Router>
    <React.Fragment>
      <Helmet defaultTitle={AppConfig.appName} titleTemplate={`${AppConfig.appName} | %s`} />
      <React.Suspense fallback={<FillLoader />}>
        <Switch>
          {PublicRoutes.map((route, i) => {
            return <PublicRoute key={i} {...route} />;
          })}
          {PrivateRoutes.map((route, i) => {
            return <PrivateRoute key={i} {...route} />;
          })}
          <Route path="/contact-us/:id/edit" component={EditContactUs} />
          <Route render={NoMatch} />
        </Switch>
      </React.Suspense>
    </React.Fragment>
  </Router>
);

export default AppNavigation;



// WEBPACK FOOTER //
// ./src/navigation/AppNavigation.tsx